import { IState } from '../../store';

export const getExternalTour = (state: IState): string | null => {
  return state.offerData.tours?.externalTour?.tourUrl || null;
};
